// ============================================================================
// HAI Reporting Tool - Simple Data Entry Page
// Streamlined single-page form interface for front-line healthcare workers
// ============================================================================

import { useState } from 'react';
import { SimpleEntryLayout } from '@/components/layout/SimpleEntryLayout';
import { HCAISurveillanceForm } from '@/components/forms/HCAISurveillanceForm';

export function SimpleDataEntryPage() {
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  return (
    <SimpleEntryLayout>
      <div className="space-y-6">
        {/* HCAI Surveillance Form */}
        <HCAISurveillanceForm
          onSuccess={() => {
            setSuccessMessage('HCAI case recorded successfully!');
            setTimeout(() => setSuccessMessage(null), 5000);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        />

        {/* Success Message */}
        {successMessage && (
          <div className="card bg-success-50 border-2 border-success-500">
            <div className="flex items-center gap-3">
              <span className="text-2xl">✓</span>
              <div>
                <p className="font-semibold text-success-900">{successMessage}</p>
                <p className="text-sm text-success-700">Your data has been saved and will sync when online.</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </SimpleEntryLayout>
  );
}
